// The three completion statuses (wire values shared with content). Kept in a
// dependency-free module so pure consumers (the resolver) don't pull in the store.
export const COMPLETION_NOT_STARTED = "not_started";
export const COMPLETION_STARTED = "started";
export const COMPLETION_COMPLETE = "complete";
